import { nl2br } from '../../components/sequence/shared/modals/email-modal/components/sidebar/tabs/utils/get-merge-tag-mapping-with-values';

export const convertNl2Br = (content: string): string => {
  if (!content) return '';

  // is no html detected in the content, means just plain text
  const looksLikeHtml = /<\/?[a-z][a-z0-9]*(\s+[^<>]*?)?>/i.test(content);
  if (!looksLikeHtml) {
    const text = nl2br(content);
    return `<div>${text}</div>`;
  }

  return content;
};
